var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-boundary',{ref:"errorBoundary",class:_vm.errorClasses,attrs:{"fall-back":_vm.fallback,"on-error":_vm.onError,"stop-propagation":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }